import store from "@/store";
import { ROLES, USER_TYPE, USER_PERMISSION } from "@/const/acl";

export const createSession = userData => {
    store.commit("userData/createSession", userData);
};

export const updateUser = userData => {
    store.commit("userData/updateUser", userData);
};

export const destroySession = () => {
    store.commit("userData/destroySession");
};

export const getLocalUserData = () => {
    return store.state.userData.user;
};
export const getRole = () => {
    return store.state.userData.role;
};

export const getRules = () => {
    return store.state.userData.rules;
};

export const convertToPermission = (role, type) => {
    let permission = "";
    if (role === ROLES.ADMIN && type === "") {
        permission = USER_PERMISSION[0];
    } else if (role === ROLES.MEMBER) {
        if (type === USER_TYPE.KAISEKISHI) {
            permission = USER_PERMISSION[1];
        } else if (type === USER_TYPE.KOZA) {
            permission = USER_PERMISSION[2];
        } else if (type === USER_TYPE.NINTEI) {
            permission = USER_PERMISSION[3];
        }
    } else {
        permission = "";
    }
    return permission;
};
